const bankValues = {
    none: 0,
    xxs: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 40,
};
const getBaseSpace = (variant) => {
    switch (variant) {
        case 'bank':
            return bankValues;
        /**
         * TS will never allow default condition to be true
         */
        /* istanbul ignore next */
        default:
            return bankValues;
    }
};
const space = (baseSpace) => ({
    none: `${baseSpace.none}px`,
    xxs: `${baseSpace.xxs}px`,
    xs: `${baseSpace.xs}px`,
    sm: `${baseSpace.sm}px`,
    md: `${baseSpace.md}px`,
    lg: `${baseSpace.lg}px`,
    xl: `${baseSpace.xl}px`,
    xxl: `${baseSpace.xxl}px`,
});
const getSpace = (variant) => {
    return space(getBaseSpace(variant));
};
export { getSpace, getBaseSpace };
//# sourceMappingURL=space.js.map